import { c as _c } from "react/compiler-runtime";
import { UsageLimit } from "@pages/settings/subscription-settings/usage-limit";
import { selectStorageUsedSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { formatStorageSize, getStorageUnit } from "@utils/ui-utils";

/**
 * Displays the storage usage for the current company
 * Shows the current usage for all workspaces, which available in storage property of the company context
 * Shows the max usage only if company has an active subscription, which available in quotas property of the company context
 * Max usage in quotas only available which workspace has an active subscription
 */
export function StorageUsage() {
  const $ = _c(14);
  const selectStorageUsed = useAppSelector(selectStorageUsedSelector);
  if (!selectStorageUsed) {
    return;
  }
  const storageUsed = selectStorageUsed.used;
  const storageLimit = selectStorageUsed.max;
  let t0;
  if ($[0] !== storageLimit) {
    t0 = storageLimit ? formatStorageSize(storageLimit) : undefined;
    $[0] = storageLimit;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const maxToDisplay = t0;
  const percentage = storageLimit ? storageUsed / storageLimit * 100 : undefined;
  let t1;
  if ($[2] !== storageUsed) {
    t1 = formatStorageSize(storageUsed);
    $[2] = storageUsed;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== storageUsed) {
    t2 = getStorageUnit(storageUsed);
    $[4] = storageUsed;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== storageLimit) {
    t3 = getStorageUnit(storageLimit);
    $[6] = storageLimit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== maxToDisplay || $[9] !== percentage || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <UsageLimit percentage={percentage} current={t1} max={maxToDisplay} currentUnit={t2} maxUnit={t3} decimalPlaces={2} />;
    $[8] = maxToDisplay;
    $[9] = percentage;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}